export default __webpack_public_path__ + "static/2-2890f647a457e243a002a32b06de2e03.jpg";